import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Identification from '../../entities/identification';
export function deleteIdentification(identification: Identification, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = identification.id;}
const _work = workingSet();




identification.status = 'D';
identification.addedOn = newHRTimestamp();
identification.addedBy = getCurrentUserId();
identification.importSource = targetImportSource;
identification.importId = mergeId;
store.dispatch(Actions.IdentificationActions.removeIdentificationQueue(identification));
}


